<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="计划" prop="planId" >
        <a-select disabled v-model="form.planId" placeholder="请选择计划">
          <a-select-option v-for="item in planOptions" :value="item.id" :key='item.id'>{{item.title}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="排序" prop="seq" >
        <a-input v-model="form.seq" placeholder="请输入排序" />
      </a-form-model-item>
      <a-form-model-item label="是否准备日" prop="type" v-if='form.seq==1'>
        <a-select v-model="form.type">
          <a-select-option :value="0">否</a-select-option>
          <a-select-option :value="1">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="form.type == 1" label="准备日内容" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="千卡" prop="kilocalorie" v-if="form.kilocalorie">
        <a-input style="width: 500px" readOnly v-model="form.kilocalorie" />
      </a-form-model-item>
      <a-form-model-item label="蛋白质份量" prop="proteinWeight"  v-if="form.proteinWeight">
        <a-input style="width: 500px" readOnly v-model="form.proteinWeight" />g
      </a-form-model-item>
      <a-form-model-item label="蛋白质含量百分比%" prop="proteinRatio" v-if="form.proteinRatio">
        <a-input style="width: 500px"  readOnly v-model="form.proteinRatio" />%
      </a-form-model-item>
      <a-form-model-item label="碳水化合物份量" prop="carbohydrateWeight" v-if="form.carbohydrateWeight">
        <a-input style="width: 500px" readOnly v-model="form.carbohydrateWeight" />g
      </a-form-model-item>
      <a-form-model-item label="碳水化合物含量百分比%" prop="carbohydrateRatio" v-if="form.carbohydrateRatio">
        <a-input style="width: 500px"  readOnly v-model="form.carbohydrateRatio" />%
      </a-form-model-item>
      <a-form-model-item label="脂肪份量" prop="fatWeight" v-if="form.fatWeight">
        <a-input style="width: 500px" readOnly v-model="form.fatWeight" />g
      </a-form-model-item>
      <a-form-model-item label="脂肪含量百分比%" prop="fatRatio" v-if="form.fatRatio">
        <a-input style="width: 500px"  readOnly v-model="form.fatRatio" />%
      </a-form-model-item>
      <a-form-model-item label="批量生成天数" prop="days" v-if="bathAdd == 1">
        <a-input-number style="width: 300px" :min="0" v-model="form.days" placeholder="请输入天数"  allow-clear />
      </a-form-model-item>
      <a-form-model-item label="早餐食物推荐" prop="breakfast" v-if="form.type!=1">
        <a-select
          placeholder="选择食物"
          style="width: 500px"
          @change="selectBreakfast"
          @search="breakfastSelect"
          show-search
          allow-clear
          :filterOption="false"
        >
          <a-select-option :value="item.id" v-for="item in breakFoodList" :key='item.id'>
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-table :loading="false"
                 style="margin-top: 10px"
                 size="middle"
                 rowKey="key"
                 :columns="columns"
                 :data-source="breakfasts"
                 :pagination="false"
                 :bordered="false">
          <span slot="image" slot-scope="text, record">
           <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="record.image"
                :src="record.image" preview="头像"/>
        </span>
          <span slot="weight" slot-scope="text, record">
            <a-input-number v-model:value="record.weight" @blur="saveQuantity(record,$event)"  :min="1"  />{{record.unit}}
          </span>
          <span slot="operation" slot-scope="text, record">
            <a @click="deleteBreakfast(record.key,record)">
              <a-icon type="delete" />删除
            </a>
          </span>
        </a-table>
      </a-form-model-item>
      <a-form-model-item label="午餐食物推荐" prop="lunch"  v-if="form.type!=1">
        <a-select
          placeholder="选择食物"
          style="width: 500px"
          show-search
          allow-clear
          @change="selectLunch"
          @search="lunchSelect"
          :filterOption="false"
        >
          <a-select-option :value="item.id" v-for="item in lunchFoodList" :key='item.id'>
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-table :loading="false"
                 style="margin-top: 10px"
                 size="middle"
                 rowKey="key"
                 :columns="columns"
                 :data-source="lunchs"
                 :pagination="false"
                 :bordered="false">
          <span slot="image" slot-scope="text, record">
           <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="record.image"
                :src="record.image" preview="头像"/>
        </span>
          <span slot="weight" slot-scope="text, record">
            <a-input-number v-model:value="record.weight" @blur="saveQuantity(record,$event)"  :min="1"  />{{record.unit}}
          </span>
          <span slot="operation" slot-scope="text, record">
            <a @click="deleteLunch(record.key,record)">
              <a-icon type="delete" />删除
            </a>
          </span>
        </a-table>
      </a-form-model-item>
      <a-form-model-item label="晚餐食物推荐" prop="dinner"  v-if="form.type!=1">
        <a-select
          placeholder="选择食物"
          style="width: 500px"
          show-search
          allow-clear
          @change="selectDinner"
          @search="dinnerSelect"
          :filterOption="false"
        >
          <a-select-option :value="item.id" v-for="item in dinnerFoodList" :key='item.id'>
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-table :loading="false"
                 style="margin-top: 10px"
                 size="middle"
                 rowKey="key"
                 :columns="columns"
                 :data-source="dinners"
                 :pagination="false"
                 :bordered="false">
          <span slot="image" slot-scope="text, record">
           <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="record.image"
                :src="record.image" preview="头像"/>
        </span>
          <span slot="weight" slot-scope="text, record">
            <a-input-number v-model:value="record.weight" @blur="saveQuantity(record,$event)"  :min="1"  />{{record.unit}}
          </span>
          <span slot="operation" slot-scope="text, record">
            <a @click="deleteDinner(record.key,record)">
              <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
            </a>
          </span>
        </a-table>
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDayInfo, addDayInfo, updateDayInfo } from '@/api/plan/dayInfo'
import Editor from '@/components/Editor'
// import { pageFood,listFood, delFood, getNoPage } from '@/api/food/food'
import {listPlan} from '@/api/cookbook/plan'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      // 已选择早餐食物id列表
      breakfasts: [],
      // 已选择午餐食物id列表
      lunchs: [],
      // 已选择晚餐食物id列表
      dinners: [],
      // 所有食物列表
      foodList: [],
      breakFoodList:[],
      lunchFoodList:[],
      dinnerFoodList:[],
      bathAdd:0,
      planOptions: [],
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        planId: null,

        seq: null,

        type: null,
        days:null,

        content: null,

        kilocalorie: null,

        proteinWeight: null,

        proteinRatio: null,

        carbohydrateWeight: null,

        carbohydrateRatio: null,

        fatWeight: null,

        fatRatio: null,

        breakfast: null,

        lunch: null,

        dinner: null,

        createTime: null,

        remark: null,

      },
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '图片',
          dataIndex: 'image',
          ellipsis: true,
          scopedSlots: {customRender: 'image'},
          align: 'center'
        },
        {
          title: '份量',
          dataIndex: 'weight',
          ellipsis: true,
          scopedSlots: {customRender: 'weight'},
          align: 'center'
        },
        {
          title: '基础热量',
          dataIndex: 'kilocalorieStr',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        planId: [
          { required: true, message: '计划ID ｛plan.id｝不能为空', trigger: 'blur' }
        ],
        seq: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ],
        // days: [
        //   { required: true, message: '批量生成天数不能为空', trigger: 'blur' }
        // ],
        // type: [
        //   { required: true, message: '是否准备日 0-否 1-是不能为空', trigger: 'change' }
        // ],
        // content: [
        //   { required: true, message: '准备日内容不能为空', trigger: 'blur' }
        // ],
        // kilocalorie: [
        //   { required: true, message: '千卡不能为空', trigger: 'blur' }
        // ],
        // proteinWeight: [
        //   { required: true, message: '蛋白质份量g不能为空', trigger: 'blur' }
        // ],
        // proteinRatio: [
        //   { required: true, message: '蛋白质含量百分比%不能为空', trigger: 'blur' }
        // ],
        // carbohydrateWeight: [
        //   { required: true, message: '碳水化合物份量不能为空', trigger: 'blur' }
        // ],
        // carbohydrateRatio: [
        //   { required: true, message: '碳水化合物含量百分比%不能为空', trigger: 'blur' }
        // ],
        // fatWeight: [
        //   { required: true, message: '脂肪份量g不能为空', trigger: 'blur' }
        // ],
        // fatRatio: [
        //   { required: true, message: '脂肪含量百分比%不能为空', trigger: 'blur' }
        // ],
        /*breakfast: [
          { required: true, message: '早餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]不能为空', trigger: 'blur' }
        ],
        lunch: [
          { required: true, message: '午餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]不能为空', trigger: 'blur' }
        ],
        dinner: [
          { required: true, message: '晚餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]不能为空', trigger: 'blur' }
        ]*/
      }
    }
  },
  filters: {
  },
  created () {
    this.getFoodList()
    this.getPlanOptions()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    dinnerSelect(item) {
      if(item){
        getNoPage({ name:item,categoryId:'351359153194860545'}).then(res=>{
          this.dinnerFoodList = res.data
        })
      }else{
        getNoPage({categoryId:'351359153194860545'}).then(res=>{
          this.dinnerFoodList = res.data
        })
      }
    },
    lunchSelect(item) {
      if(item){
        getNoPage({ name:item,categoryId:'351359116922519552'}).then(res=>{
          this.lunchFoodList = res.data
        })
      }else{
        getNoPage({categoryId:'351359116922519552'}).then(res=>{
          this.lunchFoodList = res.data
        })
      }

    },
    breakfastSelect(item) {
      if(item){
        getNoPage({ name:item,categoryId:'351358984193769473'}).then(res=>{
          this.breakFoodList = res.data
        })
      }else{
        getNoPage({ categoryId:'351358984193769473'}).then(res=>{
          this.breakFoodList = res.data
        })
      }
    },
    deleteBreakfast(key,record){
      console.log(key,record)
      this.breakfasts = this.breakfasts.filter(item => item.id !== record.id)
    },
    deleteLunch(key,record){
      console.log(key,record)
      this.lunchs = this.lunchs.filter(item => item.id !== record.id)
    },
    deleteDinner(key,record){
      console.log(key,record)
      this.dinners = this.dinners.filter(item => item.id !== record.id)
    },
    getPlanOptions() {
      listPlan().then(res => {
        this.planOptions = res.data
      })
    },
    onClose () {
      this.open = false
    },
    // 选择早餐处理
    selectBreakfast(val) {
      console.log('choose',val)
      let food = this.breakFoodList.find(item=>item.id==val)
      if(this.breakfasts.length>0){
        let old = this.breakfasts.find(item=>item.id==val)
        if(old){
          this.$message.error('食物：'+old.name+'已添加')
          return
        }
      }
      console.log('breakfast-choose',food)
      this.breakfasts.push({
        id:food.id,
        name:food.name,
        image:food.image,
        unit:food.unit,
        weight:food.quantity,
        kilocalorieStr:food.kilocalorie+'千卡('+(food.quantity+food.unit)+')'
      })
      console.log('breakfast',this.breakfasts)
    },
    // 选择早餐处理
    selectLunch(val) {
      console.log('choose',val)
      let food = this.lunchFoodList.find(item=>item.id==val)
      if(this.lunchs.length>0){
        let old = this.lunchs.find(item=>item.id==val)
        if(old){
          this.$message.error('食物：'+old.name+'已添加')
          return
        }
      }
      console.log('breakfast-choose',food)
      this.lunchs.push({
        id:food.id,
        name:food.name,
        image:food.image,
        unit:food.unit,
        weight:food.quantity,
        kilocalorieStr:food.kilocalorie+'千卡('+(food.quantity+food.unit)+')'
      })
      console.log('breakfast',this.breakfasts)
    },
    // 选择早餐处理
    selectDinner(val) {
      console.log('choose',val)
      let food = this.dinnerFoodList.find(item=>item.id==val)
      if(this.dinners.length>0){
        let old = this.dinners.find(item=>item.id==val)
        if(old){
          this.$message.error('食物：'+old.name+'已添加')
          return
        }
      }
      console.log('breakfast-choose',food)
      this.dinners.push({
        id:food.id,
        name:food.name,
        image:food.image,
        unit:food.unit,
        weight:food.quantity,
        kilocalorieStr:food.kilocalorie+'千卡('+(food.quantity+food.unit)+')'
      })
      console.log('breakfast',this.breakfasts)
    },
    saveQuantity(record,o){
      record.quantity = o.target.value
    },
    // 获取食物列表
    getFoodList() {
      pageFood({pageSize:10,categoryId:'351358984193769473'}).then(res=>{
        this.breakFoodList = res.data.records
      })
      pageFood({pageSize:10,categoryId:'351359116922519552'}).then(res=>{
        this.lunchFoodList = res.data.records
      })
      pageFood({pageSize:10,categoryId:'351359153194860545'}).then(res=>{
        this.dinnerFoodList = res.data.records
      })
    },

    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.bathAdd = 0
      this.breakfasts = []
      this.lunchs = []
      this.dinners = []
      this.form = {
        id: null,
        planId: null,
        seq: null,
        days:null,
        type: null,
        content: null,
        kilocalorie: null,
        proteinWeight: null,
        proteinRatio: null,
        carbohydrateWeight: null,
        carbohydrateRatio: null,
        fatWeight: null,
        fatRatio: null,
        breakfast: null,
        lunch: null,
        dinner: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (planId) {
      this.reset()
      this.formType = 1
      this.form.planId = planId
      this.open = true
      this.formTitle = '添加'
    },
    batchAdd(planId){
      this.reset()
      this.formType = 1
      this.form.planId = planId
      this.bathAdd = 1
      this.open = true
      this.formTitle = '批量添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDayInfo({"id":id}).then(response => {
        this.form = response.data
        if(this.form.breakfast){
          this.breakfasts = JSON.parse(this.form.breakfast)
        }
        if(this.form.lunch){
          this.lunchs = JSON.parse(this.form.lunch)
        }
        if(this.form.dinner){
          this.dinners = JSON.parse(this.form.dinner)
        }
        this.form.proteinRatio = this.form.proteinRatio*100
        this.form.carbohydrateRatio = this.form.carbohydrateRatio*100
        this.form.fatRatio = this.form.fatRatio*100
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          console.log('breakfast',this.breakfasts)
          console.log('lunchs',this.lunchs)
          console.log('dinners',this.dinners)
          this.form.breakfast = JSON.stringify(this.breakfasts)
          this.form.lunch = JSON.stringify(this.lunchs)
          this.form.dinner = JSON.stringify(this.dinners)
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            this.form.proteinRatio = this.form.proteinRatio/100
            this.form.carbohydrateRatio = this.form.carbohydrateRatio/100
            this.form.fatRatio = this.form.fatRatio/100
            updateDayInfo(this.form).then(res => {
              if(res.success){
                this.$message.success(
                  '修改成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }else{
                this.$message.error(res.message)
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDayInfo(this.form).then(res => {
              if(res.success){
                this.$message.success(
                  '新增成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }else{
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
